/** @jsx jsx */
import { jsx } from 'theme-ui';
import OnlineShopIcon from '../Badge/OnlineShopIcon';
import VideosIcon from '../Badge/VideosIcon';
import VirtualTastingIcon from '../Badge/VirtualTastingIcon';

/**
 *
 * @param {object} props
 * @param {keyof icons} props.type
 * @param {keyof iconVariants} [props.variant]
 * @param {import('csstype').Property.FlexDirection} [props.direction]
 * @returns
 */
export default function ProductFeatureIcon({
  type,
  variant,
  direction,
  ...rest
}) {
  const Icon = icons[type] || icons.default;
  return <Icon {...(iconVariants[variant] || iconVariants.default)} />;
}

const iconVariants = {
  onDark: { sx: { color: 'onPrimary' } },
  onPrimary: { sx: { color: 'primary' }, backgroundColor: 'white' },
  default: { sx: { color: 'primary' }, backgroundColor: 'white' },
};

const icons = {
  default: VirtualTastingIcon,
  webshop: OnlineShopIcon,
  videos: VideosIcon,
};
